// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3449":"6dbbe5dc","8747":"ae8fabfc"}[chunkId] + ".chunk.css";
};